import { authenticatedInstance } from '../index/index.service';
import { extractServiceErrorMessage } from '../shared/service-error.util';
import type {
  TenbisCallLogsPage,
  TenbisCallLogsQuery,
  TenbisMenuSyncResult,
  TenbisTestLoginResult,
  UpdateTenbisTenantConfigRequest,
} from 'shared-models/browser';

export type {
  TenbisCallDirection,
  TenbisCallKind,
  TenbisCallLogView,
  TenbisCallLogsPage,
  TenbisCallLogsQuery,
  TenbisCallStatus,
  TenbisMenuSyncResult,
  TenbisTestLoginResult,
  UpdateTenbisTenantConfigRequest,
} from 'shared-models/browser';

class AdminTenbisService {
  async list(query: TenbisCallLogsQuery = {}): Promise<TenbisCallLogsPage> {
    try {
      const response = await authenticatedInstance.get<TenbisCallLogsPage>('/tenbis/call-logs', { params: query });
      return response.data;
    } catch (error: unknown) {
      throw new Error(extractServiceErrorMessage(error, 'טעינת מעקב תן ביס נכשלה'));
    }
  }

  // Diff-only; the caller sends only changed fields, an empty diff never reaches here.
  async updateTenantConfig(tenantIdPk: number, payload: UpdateTenbisTenantConfigRequest): Promise<void> {
    try {
      await authenticatedInstance.patch<void>(`/tenbis/tenants/${tenantIdPk}/config`, payload);
    } catch (error: unknown) {
      throw new Error(extractServiceErrorMessage(error, 'עדכון הגדרות תן ביס נכשל'));
    }
  }

  async testLogin(tenantIdPk: number): Promise<TenbisTestLoginResult> {
    try {
      const response = await authenticatedInstance.post<TenbisTestLoginResult>(`/tenbis/tenants/${tenantIdPk}/test-login`);
      return response.data;
    } catch (error: unknown) {
      throw new Error(extractServiceErrorMessage(error, 'בדיקת ההתחברות לתן ביס נכשלה'));
    }
  }

  async disconnect(tenantIdPk: number): Promise<void> {
    try {
      await authenticatedInstance.post<void>(`/tenbis/tenants/${tenantIdPk}/disconnect`);
    } catch (error: unknown) {
      throw new Error(extractServiceErrorMessage(error, 'ניתוק תן ביס נכשל'));
    }
  }

  // Full-replace push of the tenant's 10bis menu (super_admin).
  async syncMenu(tenantIdPk: number): Promise<TenbisMenuSyncResult> {
    try {
      const response = await authenticatedInstance.post<TenbisMenuSyncResult>(`/tenbis/tenants/${tenantIdPk}/menu-sync`);
      return response.data;
    } catch (error: unknown) {
      throw new Error(extractServiceErrorMessage(error, 'סנכרון התפריט לתן ביס נכשל'));
    }
  }
}

export const adminTenbisService = new AdminTenbisService();
